import React, { useState, useRef, useEffect } from 'react'
import './Thor.css'
import thorImage from './thor.jpg'

const Thor = () => {

    const [isOpen, setIsOpen] = useState(false)
    const [message, setMessage] = useState('')
    const [messages, setMessages] = useState([
        {
            sender: 'thor',
            text: "Hello! I'm Thor from BadtameezDil GameStore. How can I help you today?"
        }
    ])

    const [isLoading, setIsLoading] = useState(false)

    const messagesEndRef = useRef(null)


    // Automatically scroll to the newest message
    useEffect(() => {

        messagesEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        })

    }, [messages, isLoading])


    const sendMessage = async () => {

        const trimmedMessage = message.trim()

        if (!trimmedMessage || isLoading) {
            return
        }


        // Add customer's message immediately
        setMessages(prev => [
            ...prev,
            {
                sender: 'user',
                text: trimmedMessage
            }
        ])

        setMessage('')
        setIsLoading(true)


        try {

            const response = await fetch(
                'https://badtameezdil-backend.onrender.com/thor',
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        message: trimmedMessage
                    })
                }
            )


            const data = await response.json()

if (response.status === 429) {
    setMessages(prev => [
        ...prev,
        {
            sender: 'thor',
            text: "You've reached today's Thor chat limit. You can ask Thor up to 5 questions per day. Please come back tomorrow! 😊"
        }
    ])
    return
}

if (!response.ok || !data.success) {
    throw new Error(
        data.error || 'Thor could not respond.'
    )
}


            const cleanReply = data.reply
            .replace(/\*\*/g, '')
            .replace(/^\s*\*\s+/gm, '• ')

             setMessages(prev => [
            ...prev,
            {
        sender: 'thor',
        text: cleanReply
            }
       ])

        } catch (error) {

            console.error('Thor error:', error)

            setMessages(prev => [
                ...prev,
                {
                    sender: 'thor',
                    text: "Sorry, I'm having trouble connecting right now. Please try again or contact BadtameezDil GameStore through Contact Us."
                }
            ])

        } finally {

            setIsLoading(false)

        }

    }


    const handleKeyDown = (e) => {

        if (e.key === 'Enter' && !e.shiftKey) {

            e.preventDefault()
            sendMessage()

        }

    }


    return (
        <>

            {/* Floating Thor Button */}
      
            {!isOpen && (

                <button
                    className="thor-floating-button"
                    onClick={() => setIsOpen(true)}
                    aria-label="Open Thor assistant"
                >

                    {/* Temporary icon.
                        We will replace this with your Thor
                        superhero image later. */}

                    <img
                src={thorImage}
                alt="Thor"
                className="thor-floating-image"
            />

                </button>

            )}


            {/* Chat Window */}

            {isOpen && (

                <div className="thor-chat-window">

                    {/* Header */}

                    <div className="thor-header">

                        <div className="thor-header-left">

                            <div className="thor-header-icon">
                         <img
                         src={thorImage}
                         alt="Thor"
                        />
                    </div>

                            <div>
                                <h3>Thor</h3>

                                <span>
                                    BadtameezDil GameStore
                                </span>
                            </div>

                        </div>


                        <button
                            className="thor-close-button"
                            onClick={() => setIsOpen(false)}
                            aria-label="Close Thor"
                        >
                            ×
                        </button>

                    </div>


                    {/* Messages */}

                    <div className="thor-messages">

                        {messages.map((msg, index) => (

                            <div
                                key={index}
                                className={`thor-message-row ${msg.sender}`}
                            >

                                {msg.sender === 'thor' && (

                                    <div className="thor-message-icon">
                                 <img
                                src={thorImage}
                                alt="Thor"
                            />
                            </div>
                                )}

                                <div
                                    className={`thor-message ${msg.sender}`}
                                >
                                    {msg.text}
                                </div>

                            </div>

                        ))}


                        {/* Loading indicator */}

                        {isLoading && (

                            <div className="thor-message-row thor">

                                <div className="thor-message-icon">
                                    ⚡
                                </div>

                                <div className="thor-message thor typing">

                                    <span></span>
                                    <span></span>
                                    <span></span>

                                </div>

                            </div>

                        )}

                        <div ref={messagesEndRef}></div>

                    </div>


                    {/* Input */}

                    <div className="thor-input-area">

                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Ask Thor anything..."
                            rows="1"
                            disabled={isLoading}
                        />

                        <button
                            onClick={sendMessage}
                            disabled={
                                !message.trim() || isLoading
                            }
                            aria-label="Send message"
                        >
                            ➤
                        </button>

                    </div>

                </div>

            )}

        </>
    )
}

export default Thor